import useBRData from "./usebrdata";
import { useState } from "react";

// This hook is a specialisation of the useBRData hook
// it only fetches data for the Team info
// Thjis is done to simjplify what is in the context, as the manipulation of the data happens here kkeeping it invisible in context and when using it.
// TYhis hook should return ONLY the data relevant to the team
const useTeam = (teamId, accessKey) => {
  const { data } = useBRData("t", { teamid: teamId }, accessKey);
  let team;

  if (data && data.teams) {
    team = data.teams[teamId];
  }

  return { data: team };
};

export default useTeam;
